import React from 'react';

export default function Button({ children, variant = 'primary', className = '', ...props }) {
  const baseStyle = "px-4 py-2 rounded-md font-medium transition-colors duration-200 flex items-center justify-center gap-2";
  const variants = {
    primary: "bg-forest-green text-white hover:bg-dark-green",
    secondary: "bg-amber text-white hover:bg-orange-600",
    outline: "border-2 border-forest-green text-forest-green hover:bg-forest-green hover:text-white",
    ghost: "text-forest-green hover:bg-tan"
  };

  return (
    <button className={`${baseStyle} ${variants[variant]} ${className}`} {...props}>
      {children}
    </button>
  );
}